import { OnboardingSurvey } from "src/global/ui/OnboardingSurvey/OnboardingSurvey.tsx"

export const UserOnboardingWrapper = () => {
  return <OnboardingSurvey />
}
